export default __webpack_public_path__ + "static/media/Fig2.2e24272a.jpg";